import React, { ReactNode } from "react";
import { Form, Alert } from 'react-bootstrap'
import { connect } from "react-redux";
import { ValidatableForm } from "../components/ValidatableForm"
import { QUOTE_STEPS } from "../AppConstants";
import { validationUtils } from "../validation/Validation";
import { IQuoteStepState, IQuoteStepComponentProps } from "../components/interfaces";
import Utilities from "../classes/Utilities";
import Header from "../components/Header";
import ButtonContinue from "../components/ButtonContinue";
import { IQuoteApiClient, IPaths } from "../classes/Domain";
import QuoteActions from "../state/appActions";
import { IAppState } from "../state/interfaces";


interface IState extends IQuoteStepState {
    zipCode: string,
    stateCode: string;
}

export interface IProps extends IQuoteStepComponentProps {
    nextPageUrl?: string,
    header?: ReactNode | null,
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

class ChangeZip extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.next = this.next.bind(this);

        this.state = {
            zipCode: "",
            stateCode: "",
            updatingStore: false,
            errors: null
        };
    }

    componentDidMount() {
        this.props.reportCurrentStep();

        validationUtils.subscribeToValidationFailure(QUOTE_STEPS.CHANGE_ZIP,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure(QUOTE_STEPS.CHANGE_ZIP);
    }

    next() {
        this.setState({ updatingStore: true }, () => {
            this.props.updateAppState(this.state.zipCode)
                .then(() => {
                    //console.log("start quote page resolve");
                    this.props.history.push(Utilities.formatUrl(this.props.nextPageUrl ?? this.props.PATHS.QUICK_VEHICLE, ""));
                },
                    () => {
                        //console.log("start quote page reject");
                        this.setState({ ...this.state, updatingStore: false });
                    }
                );
        });
    }

    onZipChange(e: any) {
        this.setState({ ...this.state, zipCode: e.target.value });
    }

    render() {
        return (
            <div>
                { !this.props.header ? <Header /> : this.props.header}

                <div className="quote-step-body">
                    <div className="quote-step-container">
                        <div className="qContainer card">
                            <div className="card-body">

                                <ValidatableForm hasErrors={null != this.state.errors} onSubmit={this.next}>
                                    <div className="row">

                                        <div className="compare-new-form">
                                            {this.state.updatingStore
                                                ?
                                                <Alert variant={"warning"}>
                                                    Verifying zip. Please wait...
                                                    </Alert>
                                                : null
                                            }

                                            <div className="form-group mx-sm-3 mb-2">
                                                <Form.Control
                                                    onChange={(e) => this.onZipChange(e)}
                                                    placeholder="Your Zip"
                                                    disabled={this.state.updatingStore}
                                                    maxLength={5}
                                                    pattern="[0-9]*"
                                                    inputMode="numeric" />
                                                {null !== this.state.errors && validationUtils.getValidationErrorFor(this.state.errors, "zipCode")
                                                    ? <Form.Control.Feedback type="invalid">
                                                        {validationUtils.getValidationErrorFor(this.state.errors, "zipCode")}
                                                    </Form.Control.Feedback>
                                                    : null
                                                }
                                            </div>

                                            <ButtonContinue
                                                disabled={!this.state.zipCode || this.state.updatingStore}
                                                showLoading={this.state.updatingStore}
                                                onClick={this.next} />
                                        </div>
                                    </div>

                                </ValidatableForm>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.CHANGE_ZIP)),
        updateAppState: (zipCode) => dispatch(quoteActions.changeZip(zipCode))
    };
};

export default connect(mapProps, mapDispatch)(ChangeZip);